<span class="spt-a-component" (click)="onClick($event)"
  ><ng-content></ng-content
></span>
